














































































































































































































































































































import '@/assets/scss/pages/dashboard-ecommerce.scss';
import { Component, Prop, Watch } from 'vue-property-decorator';
import {
  BoxIcon,
  CalendarIcon,
  CheckIcon,
  CheckSquareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  FileTextIcon,
  FilterIcon,
  SearchIcon,
  StarIcon,
  LockIcon,
  Trash2Icon,
  TrashIcon,
  UserIcon,
  XIcon,
} from 'vue-feather-icons';
import { IDamage, IPolicy, ITag, ITask, IUser, TaskFilterDto, TaskStatus } from 'admiral-core';
import Weekday from 'dayjs/plugin/weekday';
import 'dayjs/locale/de';
import dayjs from 'dayjs';
import Multiselect from 'vue-multiselect';
import { FilterMixin } from '@/mixins/FilterMixin';
import { mixins } from 'vue-class-component';
import { TaskApi } from '@/services/TaskApi';
import { FormatMixin } from '@/mixins/FormatMixin';
import Avatar from '@/components/common/Avatar.vue';
import PolicyShort from '@/components/common/PolicyShort.vue';
import DamageShort from '@/components/common/DamageShort.vue';
import EditPolicyModal from '@/views/pages/policies/EditPolicyModal.vue';
import EditDamageModal from '@/views/pages/damages/EditDamageModal.vue';
import EditTaskModal from '@/views/pages/tasks/EditTaskModal.vue';
import { PolicyApi } from '@/services/PolicyApi';
import { DamageApi } from '@/services/DamageApi';
import { BModal } from 'bootstrap-vue';
import { BaseMixin } from '@/mixins/BaseMixin';

dayjs.extend(Weekday);
dayjs.locale('de');
export interface SortValue {
  columnName: keyof ITask;
  order: 'desc' | 'asc';
}
@Component({
  name: 'task-overview',
  components: {
    EditTaskModal,
    EditPolicyModal,
    EditDamageModal,
    PolicyShort,
    DamageShort,
    CalendarIcon,
    Multiselect,

    UserIcon,
    BoxIcon,
    SearchIcon,
    XIcon,
    FilterIcon,
    ChevronDownIcon,
    ChevronUpIcon,
    CheckSquareIcon,
    CheckIcon,
    StarIcon,
    Trash2Icon,
    TrashIcon,
    Avatar,
    FileTextIcon,
    LockIcon,
  },
})
export default class TaskOverview extends mixins(FilterMixin, FormatMixin, BaseMixin) {
  @Prop({ type: Array, default: [] })
  tasks!: ITask[];

  @Prop({ type: Array, default: [] })
  tags!: ITag[];

  @Prop({ type: Boolean, default: false })
  detailed!: boolean;

  @Prop({ type: Boolean, default: false })
  small!: boolean;

  @Prop({ type: Number, default: () => 10000 })
  itemsPerPage!: number;

  selectedTask: ITask | null = null;

  selectedPolicy?: Partial<IPolicy> = {};
  selectedDamage?: Partial<IDamage> = {};

  hoveredPolicy = '';
  hoveredDamage = '';

  currentPage = 0;
  searchQuery = '';

  sortValue: SortValue = {
    columnName: 'updatedAt',
    order: 'desc',
  };

  async toggleCompleteTask(evt: Event, task: ITask) {
    evt.stopPropagation();
    try {
      task.status =
        task.status === TaskStatus.COMPLETED || task.status === TaskStatus.ARCHIVED
          ? TaskStatus.TODO
          : TaskStatus.COMPLETED;
      await TaskApi.update(task.id, {
        status: task.status,
        tags: task.tags || [],
        dueAt: task.dueAt,
        users: task.users,
        important: task.important,
        description: task.description,
        agency: this.agency,
        title: task.title,
        files: task.files,
        newUploadedFiles: [],
      });
      this.$emit('reload');
      this.$emit('update-task', task);
    } catch (e) {
      console.log(e);
    }
  }

  openEditTaskModal(evt: Event, task: ITask) {
    if ((evt.target as HTMLElement).className.includes('custom-control-label')) {
      return;
    }

    this.$router.push({ name: 'tasks.edit', params: { id: task.id } });

    // this.selectedTask = task;
    // ((this.$refs['edit-task-modal'] as EditTaskModal).$refs['edit-task'] as BModal).show();
  }

  async openEditPolicyModal(policy: IPolicy) {
    try {
      const response = await PolicyApi.getPolicy(policy.id);
      this.selectedPolicy = response.data;
      ((this.$refs['edit-policy-modal'] as EditPolicyModal).$refs['edit-policy'] as BModal).show();
    } catch (e) {
      console.log(e);
    }
  }

  async openEditDamageModal(damage: IDamage) {
    try {
      const response = await DamageApi.getDamage(damage.id);
      this.selectedDamage = response.data;
      ((this.$refs['edit-damage-modal'] as EditDamageModal).$refs['edit-damage'] as BModal).show();
    } catch (e) {
      console.log(e);
    }
  }
  async toggleImportantTask(evt: Event, task: ITask) {
    evt.preventDefault();
    try {
      task.important = !task.important;
      await TaskApi.update(task.id, {
        status: task.status,
        tags: task.tags || [],
        dueAt: task.dueAt,
        users: task.users,
        description: task.description,
        important: task.important,
        title: task.title,
        newUploadedFiles: [],
        files: task.files,
        agency: this.agency,
      });
      this.$emit('reload');
      this.$emit('update-task', task);
    } catch (e) {
      console.log(e);
    }
  }
  async deleteTask(task: ITask) {
    try {
      await TaskApi.delete(task.id);
      this.$emit('reload');
      this.$emit('delete-task', task);
      this.$toastr.s(`Aufgabe ${task.title} erfolgreich gelöscht.`, 'Aufgabe gelöscht');
    } catch (e) {
      console.log(e);
    }
  }

  onTaskDeleted(task: ITask) {
    this.$emit('reload');
    this.$emit('delete-task', task);
  }
  async reload() {
    this.$emit('reload');
  }

  updatedTask(task: ITask) {
    this.selectedTask = task;

    this.$emit('update-task', task);
    this.$emit('reload');
  }

  tagClassById(tagId: string) {
    return this.tagClasses[
      this.tags.findIndex((tag: ITag) => tag.id === tagId) % this.tagClasses.length
    ];
  }

  get getPaginatedItems() {
    return this.filteredTasks.slice(
      this.currentPage * this.itemsPerPage,
      this.currentPage * this.itemsPerPage + this.itemsPerPage,
    );
  }

  get filteredTasks() {
    return this.tasks.filter((task: ITask) => {
      return JSON.stringify(task).toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1;
    });
  }

  firstCharacter(tagName: string) {
    const tagNameSplit = tagName.split(' ');
    let result = '';
    tagNameSplit.forEach((word: string) => {
      result += word.substr(0, 1).toUpperCase();
    });
    return result;
  }

  get sortedList() {
    const compare = (a: ITask, b: ITask) => {
      let aValue, bValue;

      if (this.sortValue.columnName === 'dueAt' || this.sortValue.columnName === 'updatedAt') {
        aValue = a[this.sortValue.columnName]
          ? dayjs(a[this.sortValue.columnName]).toDate().getTime()
          : new Date('2050-01-01').getTime();
        bValue = b[this.sortValue.columnName]
          ? dayjs(b[this.sortValue.columnName]).toDate().getTime()
          : new Date('2050-01-01').getTime();

        if (aValue < bValue) {
          return this.sortValue.order === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return this.sortValue.order === 'asc' ? 1 : -1;
        }
        return 0;
      } else {
        aValue = a['users'][0].id;
        bValue = b['users'][0].id;
        if (aValue < bValue) {
          return this.sortValue.order === 'asc' ? -1 : 1;
        }
        if (aValue > bValue) {
          return this.sortValue.order === 'asc' ? 1 : -1;
        }
        return 0;
      }
    };
    return this.getPaginatedItems.sort(compare);
  }

  sortBy(columnName: 'updatedAt' | 'dueAt' | 'users', order: 'asc' | 'desc') {
    this.sortValue = {
      columnName,
      order,
    };
  }

  pagesCount() {
    return Math.ceil(this.tasks.length / this.itemsPerPage);
  }

  async updateUserTaskFilter(user: IUser) {
    const filter: TaskFilterDto = await this.$store.getters['PreferencesModule/getTaskFilter'];

    if (filter.users?.length === 1 && filter.users[0].id === user.id) {
      filter.users = [];
    } else {
      filter.users = [user];
    }

    await this.$store.dispatch('PreferencesModule/setTaskFilter', filter);
  }

  get noTasksString() {
    const filter: TaskFilterDto = this.$store.getters['PreferencesModule/getTaskFilter'];

    if (filter.status.length === 1 && filter.status.includes(TaskStatus.COMPLETED)) {
      return 'Keine erledigten Aufgaben vorhanden.';
    } else if (filter.status.length === 1 && filter.status.includes(TaskStatus.TODO)) {
      return 'Keine offenen Aufgaben vorhanden.';
    } else if (filter.important) {
      return 'Keine wichtigen Aufgaben vorhanden.';
    }

    return 'Keine Aufgaben vorhanden';
  }

  mounted() {
    // Listen for modal hidden event globally
    this.$root.$on('bv::modal::hidden', (bvEvent: any, modalId: string) => {
      if (modalId === 'edit-task' && this.$route.name === 'tasks.edit') {
        this.$router.replace({ name: 'tasks' });
      }
    });
  }

  @Watch('selectedTask')
  onSelectedTaskChange() {
    if (this.selectedTask) {
      ((this.$refs['edit-task-modal'] as EditTaskModal).$refs['edit-task'] as BModal).show();
    }
  }
}
